import {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import PropTypes from 'prop-types';

import ParsedMarkdown from './ParsedMarkdown';
import CountdownTimer from './CountdownTimer';

const Welcome = ({
  anchor,
  points,
  richTextCopy,
  headerSize,
  date,
  copy,
  subHeader,
}) => {
  const [countdownTarget, setCountdownTarget] = useState(null);
  const HeaderSize = headerSize ? headerSize.toLowerCase() : 'h2';

  useEffect(() => {
    if (date) {
      const dateInstance = new Date(date);
      setCountdownTarget(dateInstance);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run once
  }, [date]);

  const hasCountdownEnded = useMemo(() => (
    countdownTarget ? countdownTarget.getTime() <= Date.now() : false
  ), [countdownTarget]);

  const renderCopy = useCallback(() => {
    if (date) {
      return (
        <CountdownTimer
          copy={copy}
          header={subHeader}
          stretched={false}
          countdownTarget={date}
        />
      );
    }

    return copy;
  }, [date, copy, subHeader]);

  return !hasCountdownEnded && (
    <section id={anchor || undefined} className="welcome" data-testid="welcome">
      <div className="welcome__content">
        <HeaderSize className="welcome__content__copy">
          {renderCopy()}
        </HeaderSize>
        {richTextCopy?.markdown && (
          <ParsedMarkdown
            className="welcome__content__rich-copy"
            options={{ forceBlock: true }}
          >
            {richTextCopy.markdown}
          </ParsedMarkdown>
        )}
        {points?.length > 0 && (
          <div className="welcome__content__points">
            {points.map((point, index) => (
              <p
                className="welcome__content__points__point"
                key={index}
              >{point.copy}</p>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

Welcome.propTypes = {
  copy: PropTypes.string.isRequired,
  date: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
  anchor: PropTypes.string,
};

export default Welcome;
